import { ONBOARDING_VIDEO_TUTORIAL_KEY } from '../tutorial-reducers/onboarding-video';
import { getTutorialState } from '../selectors';

/**
 * Selector that determines whether the onboarding video tutorial is still active - i.e. will be shown when the user
 * clicks on the next task item
 * @param state the redux state
 * @returns {boolean} whether it is active
 */
export const selectOnboardingTutorialActive = state => {
    const tutorialState = getTutorialState(state, ONBOARDING_VIDEO_TUTORIAL_KEY);
    return !!(tutorialState && tutorialState.get('active'));
};
